import type { WireFormat } from "./transport_codec.js";

const OVERRIDE_KEY = 'http_transport';

function readOverride(): WireFormat | null
{
  try
  {
    const raw = localStorage.getItem( OVERRIDE_KEY );
    return raw === 'msgpack' || raw === 'json' ? raw : null;
  }
  catch
  {
    return null;
  }
}

export class TransportFlags
{
  private static config_default: WireFormat = 'json';

  public static setConfigDefault( msgpack: boolean ): void
  {
    this.config_default = msgpack ? 'msgpack' : 'json';
  }

  public static current(): WireFormat
  {
    return readOverride() ?? this.config_default;
  }

  public static setOverride( format: WireFormat | null ): void
  {
    try
    {
      if ( format ) localStorage.setItem( OVERRIDE_KEY, format );
      else localStorage.removeItem( OVERRIDE_KEY );
    }
    catch {}
  }

  public static describe(): { current: WireFormat; override: WireFormat | null; config_default: WireFormat }
  {
    return { current: this.current(), override: readOverride(), config_default: this.config_default };
  }
}
